<template>
  <div id="dashbord" :class="{ active: getDrawer }">
    <div id="sidebar1" class="d-block d-lg-none d-xl-none">
        <div v-if="auth.access_token && $store.getters.getAuthRole[0]=='user'">
            <ul class="list-unstyled mb-0 py-3 pt-md-1">
              <li><router-link class="" :to="{ name: 'register' }"><i class="fas fa-edit"></i> {{$t("message.new_registration")}}</router-link></li>
              <li><router-link  :to="{ name: 'myRegistration' }" :class="{active:currentRouteName=='myRegistration'}"><i class="fas fa-list-alt"></i> {{$t("message.myinformation_registration")}}</router-link></li>
              <li><router-link  :to="{ name: 'shoppingCard' }" :class="{active:currentRouteName=='shoppingCard'}"><i class="fas fa-shopping-cart"></i> {{$t("message.shoping_cart")}}</router-link></li>
              <li><router-link :to="{ name: 'paymentHistory' }" :class="{active:currentRouteName=='paymentHistory'}"><i class="fas fa-money-check-alt"></i> {{$t("message.payment_history")}}</router-link></li>
              <li v-if="getParticipant.participant_type==2"><router-link  :to="{ name: 'myMember' }" :class="{active:currentRouteName=='myMember'}"><i class="fas fa-id-card"></i> {{$t("message.member")}}</router-link></li>
              <li><router-link :to="{ name: 'changePassword' }" :class="{active:currentRouteName=='changePassword'}"><i class="fas fa-key"></i> {{$t("message.change_password")}}</router-link></li>
              <li><router-link :to="{ name: 'personal' }" :class="{active:currentRouteName=='personal'}"><i class="fas fa-user"></i> {{$t("message.profile")}}</router-link></li>
            </ul>
            <div class="p-2">
                <button class="btn btn-secondary me-2" @click="changeLanguage">
                  <img
                    v-if="$store.state.lan == 'kh'"
                    style="width: 20px;"
                    src="@/assets/images/en.svg"
                  />
                  <img v-else src="@/assets/images/kh.svg" style="width: 20px;"/>
                </button>

                <button class="btn btn-secondary" @click="logout"> 
                    {{$t("message.logout")}} 
                    <i class="fas fa-sign-out-alt"></i>
                </button>
            </div>
        </div>
        <div v-if="!auth.access_token">
            <ul class="list-unstyled mb-0 py-3 pt-md-1">
              <li><router-link class="" :to="{ name: 'SingUp' } "><i class="fas fa-edit"></i> {{$t("message.create_account")}}</router-link></li>
              <li><router-link  :to="{ name: 'SystemLogin' }" :class="{active:currentRouteName=='SystemLogin'}"><i class="fas fa-list-alt"></i> {{$t("message.login")}}</router-link></li>
              
            </ul>
            <div class="p-2">
                <button class="btn btn-secondary me-2" @click="changeLanguage">
                  <img
                    v-if="$store.state.lan == 'kh'"
                    style="width: 20px;"
                    src="@/assets/images/en.svg"
                  />
                  <img v-else src="@/assets/images/kh.svg" style="width: 20px;"/>
                </button>
            </div>
        </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import axios from "@/axios";
export default {
  components: {},
  data() {
    return {
      view: 0,
    };
  },
  computed: { 
    ...mapGetters({
      getParticipant:'getParticipant',
      getDrawer:'getDrawer',
      auth: "getAuth"
    }),
    currentRouteName() {
        return this.$route.name;
    }
  },
  methods: {
    toggle(){
      var element = document.getElementById("dashbord");
      if(element.className=='active'){
        element.classList.remove("active");
      }else{
          element.classList.add("active");
      }
     
    },
    changeLanguage() {
      this.$i18n.locale = this.$i18n.locale == "en" ? "kh" : "en";
      this.$store.dispatch("act_changLanguage");
    },
    async logout() {
      //this.act_logoutAuth();
      this.$swal
        .fire({
          title: this.$t("message.do_you_want_to_logout"),
          showCancelButton: true,
          confirmButtonText: this.$t("message.yes"),
          cancelButtonText: this.$t("message.no")
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const respone = await axios.post("logmeout", {}, {
              headers: {
                Authorization: "Bearer " + this.$store.getters.getAuthToken
              }
            });
            if (respone.status == 200) {
               this.$store.dispatch("act_logoutAuth");
              this.$router.push({ name: "Home" });
            }
          }
        });
    },
  },
  created() {},
  mounted() {
    // $("#sidebarCollapse").on("click", function () {
    //     $("#sidebar").toggleClass("active");
    // });
  }
};
</script>
<style scoped>
@media print {
    .container{
        width: 100%;
        margin: auto;
        padding: 0;
        font-size: 11pt;
         margin-left: 0 !important;
    }
    div.container{
      width: 100%;
        margin: auto;
        padding: 0;
        font-size: 11pt;
         margin-left: 0 !important;
    }
}
.myRegistration{
  padding-bottom: calc(100vh - 70vh);
}


div.content {
  margin-left: 0px;
  /* padding: 25px; */
  height: auto;
  margin-top: 0;
  padding-bottom: 150px;
}

#dashbord.active .content {
  margin-left: 0px;
  /* padding: 25px; */
  height: auto;
  margin-top: 0;
  padding-bottom: 150px;
}

@media screen and (max-width: 400px) {
  .sidebar a {
    text-align: center;
    float: none;
  }
}
.footer {
  margin-left: 200px;
}

#sidebar1 {
    min-width: 250px;
    max-width: 250px;
    background-color: #f1f1f1;
    color: black;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    /* position: relative; */
    position: fixed;
    height: 100%;
    overflow: auto;
    padding-top: 50px;
    margin-left: -250px;
    overflow-x: hidden;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

#dashbord.active #sidebar1 {
    margin-left: 0px;
    z-index: 99999;
}
#sidebar1 h1 {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 30px;
}
#sidebar1 h1 .logo {
    color: #fff;
}
#sidebar1 h1 .logo span {
    font-size: 14px;
    color: #44bef1;
    display: block;
}
#sidebar1 ul.components {
    padding: 0;
}
#sidebar1 ul li {
    font-size: 16px;
}
#sidebar1 ul li > ul {
    margin-left: 10px;
}
#sidebar1 ul li > ul li {
    font-size: 14px;
}
#sidebar1 ul li a {
    padding: 10px;
    display: block;
    color: black;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    text-decoration: none;
    
}
#sidebar1 ul li a span {
    color: #44bef1;
}
#sidebar1 ul li a:hover {
  background-color: #555;
  color: white;
}
#sidebar1 ul li.active > a {
    background: transparent;
    color: #ccc;
}

#sidebar1 .custom-menu {
    display: inline-block;
    position: absolute;
    top: 20px;
    right: 0;
    margin-right: -20px;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
}
@media (prefers-reduced-motion: reduce) {
    #sidebar1 .custom-menu {
        -webkit-transition: none;
        -o-transition: none;
        transition: none;
    }
}
#sidebar1 .custom-menu .btn {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    position: relative;
}
#sidebar1 .custom-menu .btn i {
    margin-right: -40px;
    font-size: 14px;
}
#sidebar1 .custom-menu .btn.btn-primary {
    background: transparent;
    border-color: transparent;
}
#sidebar1 .custom-menu .btn.btn-primary:after {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: "";
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    background: #3445b4;
    border-radius: 10px;
}
#sidesidebar1bar .custom-menu .btn.btn-primary:hover,
#sidebar1 .custom-menu .btn.btn-primary:focus {
    background: transparent !important;
    border-color: transparent !important;
}
a[data-toggle="collapse"] {
    position: relative;
}
.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
@media (max-width: 991.98px) {
    #sidebarCollapse span {
        display: none;
    }
}
#content {
    width: 100%;
    padding: 0;
    min-height: 100vh;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
}
.btn.btn-primary {
    background: #3445b4;
    border-color: #3445b4;
}
.btn.btn-primary:hover,
.btn.btn-primary:focus {
    background: #3445b4 !important;
    border-color: #3445b4 !important;
}
.footer p {
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
}
.form-control {
    height: 40px !important;
    background: #fff;
    color: #000;
    font-size: 13px;
    border-radius: 4px;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: transparent;
}
.form-control:focus,
.form-control:active {
    border-color: #000;
}
.form-control::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: rgba(255, 255, 255, 0.5);
}
.form-control::-moz-placeholder {
    /* Firefox 19+ */
    color: rgba(255, 255, 255, 0.5);
}
.form-control:-ms-input-placeholder {
    /* IE 10+ */
    color: rgba(255, 255, 255, 0.5);
}
.form-control:-moz-placeholder {
    /* Firefox 18- */
    color: rgba(255, 255, 255, 0.5);
}
.subscribe-form .form-control {
    background: #3b4ec6;
}



</style>
